export default __webpack_public_path__ + "static/media/nav_detail_img_15.7f9510d8.jpg";